export default {
	home: {
		welcome: 'Welcome'
	}
};
